


























import { Prop, Component, Vue } from 'vue-property-decorator'
import { Media, WonenObject } from '@/api/realworks-types'

@Component
export default class TypeformResponsesDetailWonenObject extends Vue {
    @Prop({ required: true }) wonenObject!: WonenObject

    get media(): Media[] {
        return Object.values(this.wonenObject.media)
    }

    get firstPhoto(): Media {
        return this.media.find(media => media.soort === 'HOOFDFOTO')
    }

    get title(): string {
        const title = this.wonenObject?.algemeen?.woonhuistype || ''

        return title.substring(0, 1).toUpperCase()
             + title.substring(1).toLowerCase()
    }

    get street(): string {
        return [
            this.wonenObject.adres.straat,
            this.wonenObject.adres.huisnummer,
            this.wonenObject.adres.huisnummertoevoeging,
        ].join(' ')
    }

    get address(): string {
        return [
            this.wonenObject.adres.postcode,
            this.wonenObject.adres.plaats,
        ].join(' ')
    }
}
